import React, { useEffect } from 'react';
import styled from 'styled-components';

import { useGlobalContext } from '../../context/globalContext';
import { InnerLayout } from '../../styles/Layout';

import History from '../../History/History';
import Chart from '../Chart/Chart';

import { dollar } from '../../utils/Icons';

function Dashboard() {
    const {
        totalExpenses,
        incomes,
        expenses,
        totalIncome,
        totalBalance,
        getIncomes,
        getExpenses
    } = useGlobalContext();

    useEffect(() => {
        getIncomes();
        getExpenses();
    }, [getIncomes, getExpenses]);

    const minIncome =
        incomes.length > 0
            ? Math.min(...incomes.map((item) => item.amount))
            : 0;

    const maxIncome =
        incomes.length > 0
            ? Math.max(...incomes.map((item) => item.amount))
            : 0;

    const minExpense =
        expenses.length > 0
            ? Math.min(...expenses.map((item) => item.amount))
            : 0;

    const maxExpense =
        expenses.length > 0
            ? Math.max(...expenses.map((item) => item.amount))
            : 0;

    return (
        <DashboardStyled>
            <InnerLayout>
                <h1>All Transactions</h1>

                <div className="stats-con">
                    <div className="chart-con">
                        <Chart />

                        <div className="amount-con">
                            <div className="income">
                                <h2>Total Income</h2>
                                <p>
                                    {dollar} {totalIncome().toLocaleString()}
                                </p>
                            </div>

                            <div className="expense">
                                <h2>Total Expense</h2>
                                <p>
                                    {dollar} {totalExpenses().toLocaleString()}
                                </p>
                            </div>

                            <div className="balance">
                                <h2>Total Balance</h2>
                                <p>
                                    {dollar} {totalBalance().toLocaleString()}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="history-con">
                        <History />

                        <h2 className="salary-title">
                            Min <span>Salary</span> Max
                        </h2>

                        <div className="salary-item">
                            <p>${minIncome.toLocaleString()}</p>
                            <p>${maxIncome.toLocaleString()}</p>
                        </div>

                        <h2 className="salary-title">
                            Min <span>Expense</span> Max
                        </h2>

                        <div className="salary-item">
                            <p>${minExpense.toLocaleString()}</p>
                            <p>${maxExpense.toLocaleString()}</p>
                        </div>
                    </div>
                </div>
            </InnerLayout>
        </DashboardStyled>
    );
}

const DashboardStyled = styled.div`
    .stats-con {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        gap: 1.5rem;
    }

    .chart-con {
        grid-column: 1 / 4;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }

    .chart-con > div:first-child {
        flex: 1;
        min-height: 0;
    }

    .amount-con {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;
    }

    .income,
    .expense,
    .balance {
        background: #fcf6f9;
        border: 2px solid #ffffff;
        box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.06);
        border-radius: 20px;
        padding: 0.8rem;
        overflow: hidden;
    }

    .income h2,
    .expense h2,
    .balance h2 {
        font-size: clamp(0.75rem, 1vw, 1rem);
        white-space: nowrap;
    }

    .income p,
    .expense p,
    .balance p {
        font-size: clamp(1rem, 1.8vw, 2rem);
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .balance {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .balance p {
        color: var(--color-green);
        opacity: 0.6;
    }

    .history-con {
        grid-column: 4 / -1;
        overflow-y: auto;
    }

    .history-con h2 {
        margin: 0.8rem 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .salary-title {
        font-size: 1.1rem;
    }

    .salary-title span {
        font-size: 1.4rem;
    }

    .salary-item {
        background: #fcf6f9;
        border: 2px solid #ffffff;
        box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.06);
        padding: 0.8rem 1rem;
        border-radius: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .salary-item p {
        font-weight: 600;
        font-size: clamp(0.9rem, 1.2vw, 1.4rem);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export default Dashboard;